module.exports = __webpack_public_path__ + "static/media/volumeOn.08d1a3c9.svg";